import React, { useState } from 'react';

import * as CalculatorFlow from '../shared/calculator_flow';

import RaiseNowPaymentWidget from './raise_now_payment_widget';

const INITIALIZED = 'initialized';
const PAYING = 'paying';

const openPayment = (switchToPayment, setPaymentStatus) => {
  switchToPayment();
  setPaymentStatus(PAYING);
}

export default ({ price, displayState, switchToPayment, portfolio }) => {
  const [paymentStatus, setPaymentStatus] = useState(INITIALIZED);

  if(displayState === CalculatorFlow.CALCULATE) {
    return (
      <button onClick={() => openPayment(switchToPayment, setPaymentStatus)}>{portfolio.callToActionTitle}</button>
    );
  } else if(displayState === CalculatorFlow.PAYMENT || displayState === CalculatorFlow.MANAGE) {
    return (
      <RaiseNowPaymentWidget portfolio={portfolio} price={price} />
    );
  } else {
    return null;
  }
}
